/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One official test case from the test data, imported as a private test case.
 * @export
 * @interface ImportedTestCase
 */
export interface ImportedTestCase {
    /**
     * 
     * @type {string}
     * @memberof ImportedTestCase
     */
    driver_code: string;
    /**
     * 
     * @type {number}
     * @memberof ImportedTestCase
     */
    points: number;
}

/**
 * Check if a given object implements the ImportedTestCase interface.
 */
export function instanceOfImportedTestCase(value: object): value is ImportedTestCase {
    if (!('driver_code' in value) || value['driver_code'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function ImportedTestCaseFromJSON(json: any): ImportedTestCase {
    return ImportedTestCaseFromJSONTyped(json, false);
}

export function ImportedTestCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportedTestCase {
    if (json == null) {
        return json;
    }
    return {
        
        'driver_code': json['driver_code'],
        'points': json['points'],
    };
}

export function ImportedTestCaseToJSON(json: any): ImportedTestCase {
    return ImportedTestCaseToJSONTyped(json, false);
}

export function ImportedTestCaseToJSONTyped(value?: ImportedTestCase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'driver_code': value['driver_code'],
        'points': value['points'],
    };
}

